export default function RectifierAlarm(){
    return (
        <>
        <h1>Working progress</h1>
        </>
    )
}